module.exports = __webpack_public_path__ + "static/media/hksingh_4aDFb7fXl3.d68c3555.jpeg";